import { Announcement } from '@/types'
import { useFetchWithInterceptor } from '@/use'
import { toRaw } from 'vue'

export const getAnnouncements = async (): Promise<Announcement[]> => {
  const { response, request } = useFetchWithInterceptor<Announcement[]>(`${import.meta.env.VITE_API_URL}/announcement`)
  await request()
  if (response.value) {
    return toRaw(response.value)
  } else {
    throw new Error('Response is undefined')
  }
}
